import axios from "axios";
import { tryCatchHandlr } from "@shared/Utilities"
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

export const getEnvoyReferralsFormDataApi = async (personId) => {
  const [res, err] = await tryCatchHandlr(axios.get(`/api/v4/contact_people/${personId}/envoy_referrals/form_options`))

  return { res, err }
};

export const postEnvoyReferralApi = async (personId, data) => {
  const [res, err] = await tryCatchHandlr(axios.post(`/api/v4/contact_people/${personId}/envoy_referrals`, data, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-csrf-token": window.ReactOnRails.authenticityToken(),
    }
  }))

  return { res, err }
}

export const getGoogleMapsAutoCompleteApi = async (searchQuery) => {
  const [res, err] = await tryCatchHandlr(caseTransformingAxios.get("/maps/autocomplete", {
    params: { searchQuery, supportedTypes: 'address' },
  }))

  return { res, err }
}

export const getGoogleDetailsByPlaceIdApi = async (placeId) => {
  const [res, err] = await tryCatchHandlr(caseTransformingAxios.get("/maps/details", {
    params: { placeId },
  }))

  return { res, err }
}

export const getStandardizedAddressApi = async (slug) => {

  const [res, err] = await tryCatchHandlr(caseTransformingAxios.get(`/api/v4/person/${slug}/standardized_addresses`));

  return { res, err }
}

export const getSuggestedAddressCheck = async ({ streetAddress, secondaryAddress, city, locality, postalCode, country }) => {
  const [res, err] = await tryCatchHandlr(caseTransformingAxios.get(`/api/v4/person/suggest_standardized_address`, {
    params: {
      streetAddress,
      secondaryAddress,
      city,
      locality,
      postalCode,
      country,
    },
  }));

  return { res, err }
}

export const getTimelineEmailApi = async (personUuid, interactionId) => {
  const [res, err] = await tryCatchHandlr(
    axios.get(`/api/v4/person/${personUuid}/timeline_email/${interactionId}`),
  );

  return { res, err };
};

export const getTimelineGmailThreadApi = async (personUuid, threadId) => {
  const [res, err] = await tryCatchHandlr(
    axios.get(`/api/v4/person/${personUuid}/timeline_gmail_thread/${threadId}`),
  );

  return { res, err };
};

export const getInkedCampaignThumbnailApi = async (campaignId) => {
  const [res, err] = await tryCatchHandlr(axios.get(`/api/v4/inked/campaigns/${campaignId}/thumbnail`));

  return { res, err };
};

export const getInkedCampaignPreviewLinkApi = async (campaignId, deliveryId) => {
  const [res, err] = await tryCatchHandlr(
    axios.post(
      `/api/v4/inked/campaigns/${campaignId}/preview_link`,
      deliveryId ? { delivery_id: deliveryId } : null,
      { headers: { "x-csrf-token": window.ReactOnRails.authenticityToken() } },
    ),
  );

  return { res, err };
};

export const getInkedContactPreviewLinkApi = async (personUuid) => {
  const [res, err] = await tryCatchHandlr(
    axios.post(`/api/v4/inked/contacts/${personUuid}/preview_link`, null, {
      headers: { "x-csrf-token": window.ReactOnRails.authenticityToken() },
    }),
  );

  return { res, err };
};
